import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { Icon } from "antd";

const type = "Image";

const Image = ({ image, index, moveImage, remove, preview }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: type,
    hover(item) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;
      moveImage(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type, id: image.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  const isDeleting = image.state === "deleting";
  const isLoading = image.state === "load";

  return (
    <div
      ref={ref}
      style={{ opacity: isDragging ? 0 : 1 }}
      className="file-item"
    >
      <span alt={`img - ${image.id}`}>
        <div className="ant-upload-list-item">
          {isLoading ? (
            <div className="card ant-upload-list-item-info">
              <span>
                <img
                  alt={`img - ${image.id}`}
                  src="/img/loadingnew.gif"
                  className="ant-upload-list-item-image"
                />
              </span>
            </div>
          ) : (
            <>
              <div
                className="card ant-upload-list-item-info"
                style={{ position: "relative" }}
              >
                <span>
                  <img
                    alt={`img - ${image.id}`}
                    src={image.url}
                    className="ant-upload-list-item-image item-img"
                    style={{ opacity: isDeleting ? 0.3 : 1, transition: "opacity 0.15s" }}
                  />
                </span>
                {isDeleting && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.5)",
                      borderRadius: 4,
                    }}
                  >
                    <Icon type="loading" style={{ fontSize: 22, color: "#d32f2f" }} />
                  </div>
                )}
              </div>
              {!isDeleting && (
                <span className="ant-upload-list-item-actions">
                  <Icon
                    type="eye"
                    onClick={() => preview(index)}
                  />
                  <Icon
                    type="delete"
                    onClick={() => remove(index, image.id)}
                  />
                </span>
              )}
            </>
          )}
        </div>
      </span>
    </div>
  );
};

const CarFileList = ({ images, moveImage, remove, preview }) => (
  <section className="file-list">
    {images.map((image, index) => (
      <Image
        key={`${image.id}-image`}
        image={image}
        index={index}
        moveImage={moveImage}
        remove={remove}
        preview={preview}
      />
    ))}
  </section>
);

export default CarFileList;
